goog.module('yext.location.variant.StringOption');
goog.module.declareLegacyNamespace();

const TextField = goog.require('yext.textfield.TextField');
const Select = goog.require('yext.location.Select');

/**
 * A field that can be implemented as TextField or Select
 * This class abstracts the implementation behind a standard interface
 *
 * @constructor
 * @author MattJS(matt@yext.com)
 */
const StringOption = function($ctx) {
  this.$ctx = $ctx;

  this.isStringField = $ctx.find('.js-text-field-input').length;

  this.setup();
};

/**
 * Construct the correct field
 */
StringOption.prototype.setup = function() {
  var self = this;

  if (this.isStringField) {
    this.stringField = new TextField(this.$ctx);
    $(this.stringField).on('update.textField', function() {
      self.emitUpdate();
    });
  } else {
    this.optionField = new Select(this.$ctx);
    $(this.optionField).on('updated', function() {
      self.emitUpdate();
    });
  }
};

/**
 * Store the current field value
 */
StringOption.prototype.storeValue = function() {
  if (this.isStringField) {
    return this.stringField.saveValue();
  } else {
    return this.optionField.storeValue();
  }
};

/**
 * Set the field's value
 * @param {!Object} field Plain object version of the field data
 */
StringOption.prototype.set = function(field) {
  if (this.isStringField) {
    this.stringField.set(field);
  } else {
    this.optionField.set(field);
  }
};

/**
 * Reset the field value
 */
StringOption.prototype.reset = function() {
  if (this.isStringField) {
    return this.stringField.reset();
  } else {
    return this.optionField.reset();
  }
};

/**
 * Emit an update message with the instance as context
 */
StringOption.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Get the field's value
 */
StringOption.prototype.getData = function() {
  if (this.isStringField) {
    return this.stringField.coreData();
  } else {
    return this.optionField.getData();
  }
};

/**
 * True if the field is empty
 */
StringOption.prototype.isEmpty = function() {
  if (this.isStringField) {
    return this.stringField.isEmpty();
  } else {
    return this.optionField.isEmpty();
  }
};

/**
 * True if the field is empty
 */
StringOption.prototype.isIndeterminate = function() {
  if (this.isStringField) {
    return this.stringField.isIndeterminate();
  } else {
    return this.optionField.isIndeterminate();
  }
};

/**
 * Clear the field's value
 */
StringOption.prototype.clear = function() {
  if (this.isStringField) {
    return this.stringField.clear();
  } else {
    return this.optionField.clear();
  }
};

exports = StringOption;
